import "UI/Template";
import "UI/Element";
import "./Base";

/** @namespace GIS.Map.Control */
NS("GIS.Map.Control");

/**
 * @class
 * @extends GIS.Map.Control.Base
 */
GIS.Map.Control.Zoom = Class(GIS.Map.Control.Base, /** @lends GIS.Map.Control.Zoom.prototype */ {
    /**
     * @type {$.<HTMLElement>}
     */
    $control: null,
    template: "GIS/Control/Zoom",
    /**
     * @inheritDoc
     */
    initialize() {
        this.ParentCall();
        this.render();
    },
    /**
     * @returns {GIS.Map.Control.Zoom}
     */
    render() {
        this.$control = UI.Template.$render(this.template, {
            control: this
        });
        this.$control.appendTo(this.target || this.map.element);

        UI.Element.initEvent("click", "on-click", this.$control, this);

        return this;
    },
    /**
     * @protected
     */
    onZoomInClick() {
        this.map.zoomIn();
    },
    /**
     * @protected
     */
    onZoomOutClick() {
        this.map.zoomOut();
    }
});
